<template>
  <div class="cookie-notice-wrapper">
    <div class="cookie-modal-main">
      <div class="cookie-modal-main-content">
        <div class="cookie-modal-container">
          <div class="cookie-top-content">
            <h4 class="cookie-top-content-head">{{ t('cookies.settings') }}</h4>
            <p class="cookie-top-content-body">
              <span v-html="t(
                'cookies.notice.main',
                { params: [{ shopname: eshopName, policyurl: policyUrl }] }
                )"
              ></span>
            </p>
          </div>
          <div class="cookie-bottom-content">
            <button
              class="cookie-bottom-content-accept-btn"
              data-action="consentToCookiesAll"
              @click="postCookieSettingsAll"
            >
              <span data-action="consentToCookiesAll">{{ t('cookies.accept') }}</span><i class="lni lni-checkmark"></i>
            </button>
            <button class="cookie-bottom-content-settings-btn" @click="openSettings">{{ t('cookies.more') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CookieConsentNamesEnum } from '../../../../vue/cookies/store/cookiesModule'
import { setCookie } from '../../../js/es6/utilities/cookie-access'
import { mapActions } from 'vuex'

export default {
  name: 'CookieNotice',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions('cookies', [
      'openSettings'
    ]),
    postCookieSettingsAll () {
      setCookie(
        CookieConsentNamesEnum.CONSENT_STATUS,
        true,
        365
      ).then(() => {
        this.$root.$emit('cookies-modal-close')
      })
    },
    eshopName () {
      return this.t('hct.eshop.name')
    },
    policyUrl () {
      return this.t('hct.eshop.policy.url')
    }
  }
}
</script>
